/**
 * Maps an {@link AnalyticsTone} to fully-static Tailwind class strings.
 *
 * Class names are spelled out in full (never interpolated) so Tailwind's
 * content scanner keeps them, and they reference the per-client semantic tokens
 * (`primary`/`success`/`warning`/`error`) so widgets re-theme automatically.
 */

import type {AnalyticsTone} from '../models/homeAnalytics.model';

interface ToneStyle {
  bg: string;
  softBg: string;
  text: string;
}

const TONE_STYLES: Record<AnalyticsTone, ToneStyle> = {
  primary: {bg: 'bg-primary', softBg: 'bg-brand-50', text: 'text-primary'},
  success: {bg: 'bg-success', softBg: 'bg-success/10', text: 'text-success'},
  warning: {bg: 'bg-warning', softBg: 'bg-warning/10', text: 'text-warning'},
  error: {bg: 'bg-error', softBg: 'bg-error/10', text: 'text-error'},
  neutral: {bg: 'bg-gray-400', softBg: 'bg-gray-100', text: 'text-gray-500'}
};

export const toneStyle = (tone: AnalyticsTone): ToneStyle => TONE_STYLES[tone];
